function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.827 7.373l-2.04.549a.667.667 0 00-.487.549 3.333 3.333 0 01-3.3 2.861H7.333a.667.667 0 00-.667.667v.667a3.333 3.333 0 003.333 3.333h1.667c.368 0 .667.298.667.667v5.717a.667.667 0 01-.561.659l-7.667 1.224a.667.667 0 01-.772-.657v-1.276a1.667 1.667 0 00-3.334 0v8a1.667 1.667 0 003.334 0v-2c0-.328.238-.607.561-.659l9.375-1.489a3.006 3.006 0 002.4-2.933v-6.585c0-.368.298-.667.667-.667h8.997c.736 0 1.333-.597 1.333-1.333V8.018a.667.667 0 00-.84-.644z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.717.513A1.32 1.32 0 0030.666 0H9.333a4 4 0 00-4 4v4c0 .736.597 1.333 1.333 1.333h13.333c.736 0 1.333-.597 1.333-1.333v-.977c0-.302.202-.566.493-.644l8.551-2.299a1.27 1.27 0 00.899-.855l.684-1.568a1.325 1.325 0 00-.243-1.144zM29.333 8C28.597 8 28 8.597 28 9.333V12a1.333 1.333 0 002.666 0V9.333c0-.736-.597-1.333-1.333-1.333z"
});

function SvgCctv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default SvgCctv;